const themeName = process.env.VUE_APP_THEME_NAME

export default [
  {
    path: '/:lang/messages',
    name: 'messages',
    component: () => import(`@/views/${themeName}/messages/index.vue`),
    meta: {
      pageTitle: 'Messages',
      middleware: 'auth',
      breadcrumb: [
        {
          text: 'Messages',
          active: true,
          to: {
            name: 'messages',
          },
        },
      ],
    },
  },
]
